













import { Component, Vue } from "vue-property-decorator";
import { eventService } from "../services/EventService";
import { DxLoadPanel } from "devextreme-vue";

@Component({
  components: { DxLoadPanel }
})
export default class LoadPanel extends Vue {
  loadingVisible: boolean = false;

  created() {
    eventService.on("LoadPanel", (value: boolean) => {
      this.loadingVisible = value;
    });
  }
}
